import React from "react";
import styled from "styled-components";
import heroImage from "./images/hero2.jpg";
import TopBar from "./Components/TopBar";
import Services from "./Components/Services";
import Contact from "./Components/Contact";
import logoBig from "./images/kelta-valkovuori.png";

const Wrapper = styled.div`
  width: 100%;
`;

const HeroImage = styled.div`
  background-image: linear-gradient(
      rgba(33, 33, 33, 0.8),
      rgba(33, 33, 33, 0.6)
    ),
    url(${heroImage});
  width: 100%;
  height: 600px;
  background-size: cover;
  background-position: center;
  display: flex;
  text-align: center;
  flex-direction: column;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 8%;
  margin: 0 1em;
`;

const Subtitle = styled.h2`
  color: #fafafa;
  font-family: "Oswald", sans-serif;
`;

const LogoContainer = styled.div`
  width: 350px;
  @media only screen and (max-width: 600px) {
    width: 300px;
  }
`;

const Logo = styled.img`
  width: 100%;
`;

function MainPage() {
  return (
    <Wrapper>
      <HeroImage>
        <TopBar />
        <TitleWrapper>
          <LogoContainer>
            <Logo src={logoBig} />
          </LogoContainer>
          <Subtitle>
            Maanrakennusta vankalla kokemuksella ja ammattitaidolla
          </Subtitle>
        </TitleWrapper>
      </HeroImage>
      <Services />
      <Contact />
    </Wrapper>
  );
}

export default MainPage;



// WEBPACK FOOTER //
// ./src/MainPage.js